import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=d4defad4&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=d4defad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4defad4",
  null
  
)

export default component.exports